import { apigateway } from "../intances/apigateway"
import toast from "react-hot-toast"

export function verifyPromotionCode(tunnelData, promotionCode, verifyPromotionPayload) {
  const API_VERIFY_PROMO_CODE_URL = `/middle-business-service/api/v2/promotions/verify/promoCode/${promotionCode}/categoryEvollisId/${verifyPromotionPayload.categoryEvollisId}`

  const API_VERIFY_PROMO_CODE_URL_PARAMS = prepareVerifyPromoCodeGetParams(
    API_VERIFY_PROMO_CODE_URL,
    verifyPromotionPayload
  )

  return apigateway(tunnelData)
    .get(API_VERIFY_PROMO_CODE_URL_PARAMS)
    .then((response) => {
      return response.data ? "VALID" : "INVALID"
    })
    .catch((error) => {
      console.error(error)
      toast.error(error.message)
    })
}

function prepareVerifyPromoCodeGetParams(url, verifyPromotionPayload) {
  let urlWithParams = url

  if (verifyPromotionPayload?.supplierId) {
    urlWithParams = urlWithParams.concat(`/supplierId/${verifyPromotionPayload.supplierId}`)
  }
  if (verifyPromotionPayload?.price) {
    urlWithParams = urlWithParams.concat(`/price/${verifyPromotionPayload.price}`)
  }
  if (verifyPromotionPayload?.duration) {
    urlWithParams = urlWithParams.concat(`/duration/${verifyPromotionPayload.duration}`)
  }

  return urlWithParams
}
